import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { Registro, RegistroForm } from './registro.model';

@Injectable({ providedIn: 'root' })
export class RegistrosService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(AppConfigService);

  private get base(): string {
    return `${this.config.apiUrl}/api/registros`;
  }

  listar(): Observable<Registro[]> {
    return this.http.get<{ data: Registro[] }>(this.base).pipe(map((r) => r.data));
  }

  crear(valores: RegistroForm): Observable<Registro> {
    return this.http.post<{ data: Registro }>(this.base, valores).pipe(map((r) => r.data));
  }

  actualizar(id: number, valores: RegistroForm): Observable<Registro> {
    return this.http.patch<{ data: Registro }>(`${this.base}/${id}`, valores).pipe(map((r) => r.data));
  }

  eliminar(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
